/* eslint-disable react/no-find-dom-node, react/destructuring-assignment,
 react/prop-types, babel/new-cap, complexity, import/no-extraneous-dependencies */
// Copyright (c) 2018 Deere & Company

import {
    DragSource,
    DropTarget,
} from 'react-dnd';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { findDOMNode } from 'react-dom';
import flow from 'lodash/flow';

const getSingleValue = (mappingTable, mappingId,
    valueToMap, valueToMapIdAttribute) => mappingTable.find(
    (item) => item[valueToMapIdAttribute] === valueToMap,
);

export const cardSource = {
    beginDrag(props) {

        return {
            card: props.card,
            index: props.index,
            listId: props.listId,
        };

    },
    endDrag(props, monitor) {

        const item = monitor.getItem();
        const dropResult = monitor.getDropResult();

        if (dropResult && dropResult.listId !== item.listId) {

            props.removeCard(item.index, item.listId);

        }

    },
};

export const cardTarget = {
    hover(props, monitor, component) {

        const dragIndex = monitor.getItem().index;
        const hoverIndex = props.index;
        const sourceListId = monitor.getItem().listId;

        if (dragIndex === hoverIndex) {

            return;

        }

        const hoverBoundingRect = findDOMNode(component).getBoundingClientRect();
        const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
        const clientOffset = monitor.getClientOffset();
        const hoverClientY = clientOffset.y - hoverBoundingRect.top;

        if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {

            return;

        }

        if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {

            return;

        }

        if (props.listId === sourceListId) {

            props.moveCard(dragIndex, hoverIndex, props.listId);

            monitor.getItem().index = hoverIndex;

        }

    },
};

class Card extends Component {

    render() {

        const {
            card,
            connectDragSource,
            connectDropTarget,
            isDragging,
        } = this.props;

        const className = isDragging ? 'dragging' : 'stationary';
        return connectDragSource(connectDropTarget(
            <div className={`card ${className}`}>
                {
                    React.cloneElement(this.props.childComponent,
                        {
                            ...this.props,
                            item: getSingleValue(
                                this.props.mappingTable,
                                this.props.mappingId,
                                card[this.props.idAttribute],
                                this.props.idAttribute,
                            ),
                        })
                }
            </div>,
        ));

    }

}

Card.displayName = 'Card';
Card.propTypes = {
    card: PropTypes.object.isRequired,
    connectDragSource: PropTypes.func,
    connectDropTarget: PropTypes.func,
    idAttribute: PropTypes.string.isRequired,
    index: PropTypes.number.isRequired,
    isDisplayValueMapped: PropTypes.bool.isRequired,
    isDragging: PropTypes.bool,
    listId: PropTypes.string.isRequired,
    mappingId: PropTypes.string,
    mappingTable: PropTypes.arrayOf(PropTypes.object),
    moveCard: PropTypes.func.isRequired,
    removeCard: PropTypes.func.isRequired,
};

export default flow(
    DropTarget('CARD', cardTarget, (connect) => ({
        connectDropTarget: connect.dropTarget(),
    })),
    DragSource('CARD', cardSource, (connect, monitor) => ({
        connectDragSource: connect.dragSource(),
        isDragging: monitor.isDragging(),
    })),
)(Card);

/* eslint-enable babel/new-cap, complexity */
